// src/services/StudentService.js
import api from "./api";
import { ENDPOINTS } from "./endpoints";

// Helper for multipart/form-data POST
// ⚠️ Do NOT manually set Content-Type - Axios automatically sets it with the boundary parameter
const postFormData = (url, data) => api.post(url, data);

// --- Student APIs ---
export const getStudents = (page) => api.get(ENDPOINTS.STUDENT.GET, { params: { page } });

export const getFilteredStudents = (name, id_number, program_id) =>
  api.get(ENDPOINTS.STUDENT.GET_FILTERED_STUDENTS, { params: { name, id_number, program_id } });

export const getClassWiseStudentList = (program_id) =>
  api.get(ENDPOINTS.STUDENT.GET_CLASS_WISE_STUDENT_LIST, { params: { program_id } });

export const getStudentsByTransportAndActivation = (mode_of_transport, is_activated, vehicle_number) =>
  api.get(ENDPOINTS.STUDENT.GET_FILTERED_STUDENTS, {
    params: { mode_of_transport, is_activated, vehicle_number, suspended: 0, paginate: 0 },
  });

export const getStudentById = (id) => api.get(`${ENDPOINTS.STUDENT.GET_STUDENT}/${id}`);

export const getStudentsByProgram = (program_id) =>
  api.get(ENDPOINTS.STUDENT.GET_STUDENT, { params: { program_id } });

export const createStudent = (data) => postFormData(ENDPOINTS.STUDENT.CREATE, data);

export const updateStudent = (id, data) => postFormData(`${ENDPOINTS.STUDENT.UPDATE}/${id}`, data);

export const deleteStudent = (id) => api.delete(`${ENDPOINTS.STUDENT.DELETE}/${id}`);

export const updateStudentStatus = (data) => api.post(ENDPOINTS.STUDENT.STATUS, { data });

export const createBulkStudents = (data) => postFormData(ENDPOINTS.STUDENT.BULK_CREATE, data);

export const updateBulkStudents = (data) => postFormData(ENDPOINTS.STUDENT.BULK_UPDATE, data);

export const directUpdateStudents = (data) => api.post(ENDPOINTS.STUDENT.DIRECT_UPDATE, data);

export const promoteStudents = (data) => api.post(ENDPOINTS.STUDENT.PROMOTE_STUDENTS, data);

export const updatePromotedStudents = (data) => api.post(ENDPOINTS.STUDENT.MANAGED_PROMOTED_STUDENTS, data);

export const bulkPromoteStudents = (data) => api.post(ENDPOINTS.STUDENT.BULK_PROMOTE, data);

export const generateActivationKey = (data) => api.post(ENDPOINTS.STUDENT.GENRATE_ACTIVATION_KEY, { data });

export const getActivatedInActivatedParentAppUserCount = () =>
  api.get(ENDPOINTS.STUDENT.PARENT_APP_ACTIVATED_INACTIVATED_USER_COUNT);

export const storeFabsDataEnrollment = (org_code, session_name) =>
  api.get(`${ENDPOINTS.STUDENT.STORE_FABS_DATA_ENROLLEMENT}/${org_code}/${session_name}`);

export const getStudentDataForSync = (org_code, session_name) =>
  api.get(`${ENDPOINTS.STUDENT.GET_STUDENT_DATA_FOR_SYNC}/${org_code}/${session_name}`);

export const syncStudentData = (data) => api.post(ENDPOINTS.STUDENT.SYNC_STUDENT_DATA, { data });

export const downloadStudentData = () => api.get(ENDPOINTS.STUDENT.DOWNLOAD_STUDENT_DATA);
